import React, { memo, useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import Button from 'design-system/Button';
import BlurAmountView from 'design-system/BlurAmountView';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import IconArrow from 'design-system/icons/IconArrow';
import useColors from 'hooks/useColors';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useTabNavigation } from 'hooks/navigation/useTabNavigation';
import { selectScrambled } from 'reducers/selectors';
import Card from 'features/feed/components/Card';
import { selectIsDefaultSpace } from 'features/spaces/reducers/selectors';
import { useAppSelector } from 'store/hooks';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import { UnavailableOnWebModal } from 'utils/packages/UnavailableOnWebModal';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { isWeb } from '../../../constants';
import { selectCreditScore, selectIsCreditScoreAvailable, selectIsCreditScoreRegistered, selectShouldShowCreditScoreInFeed, } from '../selectors';
const strings = {
    title: 'Credit score',
    track: 'Track',
};
const CreditScoreFeedCard = ({ inFeedContent }) => {
    const colors = useColors();
    const nav = useMainStackNavigation();
    const { navigateToTab } = useTabNavigation();
    const { paddingHorizontalStyle } = useAppFrameDimensions(true);
    const showInFeed = useAppSelector(selectShouldShowCreditScoreInFeed);
    const isAvailable = useAppSelector(selectIsCreditScoreAvailable);
    const isRegistered = useAppSelector(selectIsCreditScoreRegistered);
    const data = useAppSelector(selectCreditScore);
    const isDefaultSpace = useAppSelector(selectIsDefaultSpace);
    const scrambled = useAppSelector(selectScrambled);
    const onPressRow = useCallback(() => {
        navigateToTab('Borrow');
    }, [navigateToTab]);
    const onPressTrack = useCallback(() => {
        if (isWeb) {
            UnavailableOnWebModal.show('emma://borrow', strings.track);
            return;
        }
        nav.navigate('CreditScoreOnboarding');
    }, [nav]);
    if (!showInFeed || !isAvailable || !isDefaultSpace) {
        return null;
    }
    const showScore = isRegistered && !!data;
    return (<View style={paddingHorizontalStyle}>
      <Card style={[styles.container, inFeedContent && styles.feedContentSpacing]}>
        <TouchableHighlight onCard hoverOnLight underlayColor={colors.background.underlay} activeOpacity={1} onPress={showScore ? onPressRow : onPressTrack} style={styles.btn}>
          <View style={styles.row}>
            <View style={styles.label}>
              <Text Text-16>{strings.title}</Text>
              <IconArrow width={8} height={8} direction="right" style={styles.arrowIcon}/>
            </View>
            {showScore ? (<View style={styles.scoreTextContainer}>
                <BlurAmountView enabled={scrambled}>
                  <Text Numbers-16 Primary>
                    {data.score}
                  </Text>
                </BlurAmountView>
                <Text Numbers-16 Secondary>
                  {`/`}
                </Text>
                <Text Numbers-16 Secondary>
                  {data.maxScore}
                </Text>
              </View>) : (<Button brandBorder small extra cards hug title={strings.track} onPress={onPressTrack}/>)}
          </View>
        </TouchableHighlight>
      </Card>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        marginHorizontal: rem(16),
        marginBottom: rem(16),
    },
    feedContentSpacing: {
        marginBottom: rem(24),
    },
    btn: {
        padding: rem(16),
        ...(isWeb && {
            paddingVertical: rem(16),
        }),
    },
    row: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
    },
    label: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
    },
    arrowIcon: {
        marginStart: rem(16),
    },
    scoreTextContainer: {
        flexDirection: 'row',
        gap: rem(4),
    },
});
export default memo(CreditScoreFeedCard);
